export enum IndicesPasosPlataformasDigitales {
	CompletarInformacionPlataformas = 0,
  Capacidades = 1,
  TipoDeEstablecimiento = 2,
  CodigoDeConducta = 3
}
